import type { BuilderCompData, BuilderCtxProviderData, BuilderFuncLibData } from '@wix/thunderbolt-symbols'

export type EditableComponentUrls = {
	JSX: string
	SDK: string
	npmModuleName: string
}

export const buildEditorReactComponentMapping = (
	builderComponents: { [componentType: string]: BuilderCompData },
	isEditor: boolean = false,
): Record<string, string> => {
	const mapping: Record<string, string> = {}

	Object.values(builderComponents).forEach((component: BuilderCompData) => {
		const { componentUrl, editorComponentUrl, sdkUrl, moduleSpecifier } = component

		if (moduleSpecifier) {
			if (isEditor && editorComponentUrl) {
				mapping[moduleSpecifier] = editorComponentUrl
			} else if (componentUrl) {
				mapping[moduleSpecifier] = componentUrl
			}

			if (sdkUrl) {
				mapping[`${moduleSpecifier}/sdk`] = sdkUrl
			}
		}
	})

	return mapping
}
